/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";
import {
  CreateOtelDestinationInput,
  CreateOtelDestinationInput$Outbound,
  CreateOtelDestinationInput$outboundSchema,
} from "./createoteldestinationinput.js";

/**
 * Destination transport type.
 */
export const DestinationType = {
  Otel: "otel",
} as const;
/**
 * Destination transport type.
 */
export type DestinationType = ClosedEnum<typeof DestinationType>;

/**
 * Sensitive-data policy.
 */
export const SensitiveData = {
  Exclude: "exclude",
  Include: "include",
} as const;
/**
 * Sensitive-data policy.
 */
export type SensitiveData = ClosedEnum<typeof SensitiveData>;

/**
 * Form for creating a data export destination. Supply the transport configuration selected by destination_type.
 */
export type CreateDestinationForm = {
  /**
   * Destination transport type.
   */
  destinationType: DestinationType;
  /**
   * Human-readable destination name.
   */
  name: string;
  /**
   * OTEL-specific configuration supplied when creating a destination.
   */
  otel?: CreateOtelDestinationInput | undefined;
  /**
   * Sensitive-data policy.
   */
  sensitiveData?: SensitiveData | undefined;
};

/** @internal */
export const DestinationType$outboundSchema: z.ZodMiniEnum<
  typeof DestinationType
> = z.enum(DestinationType);

/** @internal */
export const SensitiveData$outboundSchema: z.ZodMiniEnum<typeof SensitiveData> =
  z.enum(SensitiveData);

/** @internal */
export type CreateDestinationForm$Outbound = {
  destination_type: string;
  name: string;
  otel?: CreateOtelDestinationInput$Outbound | undefined;
  sensitive_data: string;
};

/** @internal */
export const CreateDestinationForm$outboundSchema: z.ZodMiniType<
  CreateDestinationForm$Outbound,
  CreateDestinationForm
> = z.pipe(
  z.object({
    destinationType: DestinationType$outboundSchema,
    name: z.string(),
    otel: z.optional(CreateOtelDestinationInput$outboundSchema),
    sensitiveData: z._default(SensitiveData$outboundSchema, "exclude"),
  }),
  z.transform((v) => {
    return remap$(v, {
      destinationType: "destination_type",
      sensitiveData: "sensitive_data",
    });
  }),
);

export function createDestinationFormToJSON(
  createDestinationForm: CreateDestinationForm,
): string {
  return JSON.stringify(
    CreateDestinationForm$outboundSchema.parse(createDestinationForm),
  );
}
